import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import { I18N } from 'commons';

const ErrorContainer = ({ isSubmitting, errors, values }) => {
  const [errorMessages, setErrorMessages] = useState([])
  const Container = useRef(null)

  useEffect(() => {
    if (!isSubmitting) {
      let temp = []
      let usedId = []

      Object.keys(errors).forEach((item) => {
        if (errors[item]) {
          if (!item.includes('_') || (item.includes('_') && !usedId.includes(item.split('_')[0]))) {
            temp.push(errors[item])
            usedId.push(item.split('_')[0])
          }
        }
      })

      setErrorMessages(temp)
      if (temp.length > 0) {
        Container.current.focus()
      }
    }
  }, [isSubmitting])
  return (
    <div className="row" tabIndex="-1" ref={Container}>
      <div className='col-12'>
        {
          !!errorMessages.length &&
          <div className="error-container">
            <p className="mb-1"><I18N>form.error.messages.group.title</I18N></p>
            <ul>
            {
              Object.keys(errorMessages).map((name) => (<li key={name}><I18N>{errorMessages[name]?errorMessages[name]:''}</I18N></li>))
            }
            </ul>
          </div>
        }
      </div>
    </div>
  )
};

ErrorContainer.propTypes = {
};

export default ErrorContainer;
